<script>
import baseMixin from '@/mixins/baseMixin'

export default {
  name: 'BookingCardPolicies',
  mixins: [baseMixin],
  props: {
    policies: {
      type: Array,
      default: function() {
        return []
      },
    },
  },
  data: function() {
    return { expanded: false }
  },
  computed: {
    compPoliciesText() {
      if (this.policies.length === 0) {
        return ''
      }

      const policiesAgreed = this.policies.filter((policy) => {
        return policy.agreedUTC
      })

      return (
        this.$tc('booking.policiesAgreedText', policiesAgreed.length, {
          count: policiesAgreed.length,
        }) + ':'
      )
    },
  },
}
</script>

<template>
  <section class="policies">
    <span :class="['caption', isMobileViewPort ? 'd-block' : '']">
      {{ compPoliciesText }}
    </span>
    <v-chip
      v-for="(p, index) in policies"
      :key="'policy' + index"
      :title="p.agreedUTC"
      x-small
      class="caption transparent"
    >
      <v-icon v-if="p.agreedUTC" left x-small color="green"> mdi-check </v-icon>
      <v-icon v-else x-small left color="red"> mdi-close </v-icon>
      {{ p.typeName }}
    </v-chip>
  </section>
</template>
